import { FormControlledInput } from "ui/molecules/form/FormControlledInput";
import MedicationModalTemplate from "../organisms/MedicationModalTemplate";
import { useMedicationModal } from "../contexts/MedicationModalContext";
import { MedicationEndedWarning } from "../organisms/MedicationEndedWarning";

interface Props {
  onClose: () => void;
  medicationId: number;
}

function Content() {
  const { control, isSubmitting, medication } = useMedicationModal();

  return (
    <>
      <FormControlledInput
        id="skip_reason"
        name="skip_reason"
        label="Reason"
        placeholder="Enter reason for skipping"
        control={control}
        isRequired
        isDisabled={isSubmitting}
      />

      <MedicationEndedWarning medication={medication} className="mt-5" />
    </>
  );
}

export default function SkippedMedicationFormTemplate({
  onClose,
  medicationId,
}: Props) {
  return (
    <MedicationModalTemplate
      onClose={onClose}
      medicationId={medicationId}
      skipped
    >
      <Content />
    </MedicationModalTemplate>
  );
}
